/**
 * Phase 4: Abgleich der lokalen Kopie (Tablet/Desktop) mit dem Server.
 * Der Client merkt sich einen Stand (`cursor`) und holt danach nur Geändertes.
 */
import type { CombatDTO, NoteDetail } from './api.js';
import type { MapDTO } from './map.js';

/** Header für gepufferte Änderungen: Dieselbe Änderung wirkt nur einmal. */
export const IDEMPOTENCY_HEADER = 'idempotency-key';

/** Bereiche, die der Client als Ganzes neu lädt (Listen, Einstellungen). */
export type SyncArea = 'types' | 'files' | 'catalog' | 'campaign' | 'screen';

export interface SyncResponse {
  cursor: string;
  /** Vollständiger Stand (erster Abgleich oder zu alter Stand): Lokales komplett ersetzen. */
  reset: boolean;
  /** Geänderte (bei `reset` alle) Notizen, gefiltert wie jede Notiz-Auslieferung. */
  notes: NoteDetail[];
  deletedNotes: string[];
  /** Nur für DMs. */
  maps: MapDTO[];
  deletedMaps: string[];
  /** Nur für DMs. */
  combats: CombatDTO[];
  deletedCombats: string[];
  areas: SyncArea[];
}
